import { useAppSelector } from '../index';

export const useCurrentLang = () => {
  return useAppSelector(({ common }) => common.lang);
};

export const useLoading = () => {
  return useAppSelector(({ common }) => !!common.loading.length);
};
